<template>
	<div class="sub_contents_wrap" style="width: 1250px;">
		<br>
		<p> SK스피드메이트(주) (이하 ‘회사’라 함) 는 이용자의 개인정보를 중요시 하며, 모든 개인정보는 </p>
		<p> 『개인정보보호법』등 관련 법률상의 개인정보보호 규정을 준수하고 있습니다. </p>
		<p> 『개인정보보호법』 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같은 처리방침을 두고 있습니다. </p>
		<br>
		<li style="font-weight: bold;"> 제1조 개인정보의 처리 목적 </li>
		<p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며,  </p>
		<p>이용 목적이 변경되는 경우에는 『개인정보 보호법』 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. </p>
		<p>1.	부품 구매, 판매, 배송 및 보험사 청구 정보 제공 </p>
		<p>-	부품 구매, 판매, 배송 및 보험사 청구 정보 제공에 따른 서비스 부정이용 방지, 각종 고지․통지, 고충처리 목적으로 개인정보를 처리합니다. </p>
		<br>
		<li style="font-weight: bold;">제2조 개인정보의 처리 및 보유기간 </li>
		<p>1.	회사는 법령에 따른 개인정보 보유․이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다. </p>
		<p>2.	회사는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. </p>
		<p>3.	단, 관련 법령의 규정에 의하여 더 보존할 필요성이 있는 경우에는 법령에서 규정한 보존기간 동안 개인정보를 보유할 수 있으며  </p>
		<p> &nbsp;보유기간을 회원님에게 미리 고지하거나 개별적으로 회원님의 동의를 받은 경우에는 약속한 보존기간 동안 개인정보를 보유합니다.  </p>
		<p> &nbsp;이 경우, 회사는 보유하는 정보를 그 보유 목적으로만 이용하며, 보존기간은 아래와 같습니다. </p>
	<table>
		<thead>
			<tr>
				<th>보유 항목</th>
				<th>보유 기간</th>
				<th>법적 근거</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>계약 또는 청약철회 등에 관한 기록</td>
				<td style="font-size: 14px; font-weight: bold;">5년</td>
				<td>전자상거래 등에서의 소비자보호에 관한 법률</td>
			</tr>
			<tr>
				<td>대금결제 및 재화 등의 공급에 관한 기록</td>
				<td style="font-size: 14px; font-weight: bold;">5년</td>
				<td>전자상거래 등에서의 소비자보호에 관한 법률</td>
			</tr>
			<tr>
				<td>소지바의 불만 또는 분쟁처리에 관한 기록</td>
				<td style="font-size: 14px; font-weight: bold;">3년</td>
				<td>전자상거래 등에서의 소비자보호에 관한 법률</td>
			</tr>
			<tr>
				<td>이용자의 인터넷 등 로그기록</td>
				<td style="font-size: 14px; font-weight: bold;">3개월</td>
				<td>통신비밀보호법</td>
			</tr>
		</tbody>
	</table>
		<br>
		<li style="font-weight: bold;">제3조 처리하는 개인정보의 항목 </li>
		<p>1. 회사는 다음과 같은 목적을 위해 개인정보 항목을 처리하고 있습니다. </p>
	<table>
		<thead>
			<tr>
				<th>구분</th>
				<th>항목</th>
				<th>이용목적</th>
				<th>보유기간</th>
			</tr>
		</thead>
		<tbody>
			<tr>
        <td rowspan='3'>필수</td>
				<td>보험사 담당자 성명, 보험사 담당자 전화번호, 계좌번호, 예금주, 은행명, 차량번호</td>
				<td>보험청구서 작성</td>
				<td rowspan='3' style="font-size: 14px; font-weight: bold;">탈퇴시까지</td>
			</tr>
			<tr>
				<td>배송지 주소, 전화번호</td>
				<td>상품배송</td>
			</tr>
      <tr>
				<td>차량번호</td>
				<td>공임청구서 작성</td>
			</tr>
		</tbody>
	</table>
		<p>2.	회사는 이용자들에게 양질의 맞춤 서비스를 제공하기 위해서 이용자의 추가적인 개인정보를 선택적으로 수집하고 있습니다.  </p>
		<p> &nbsp;이 경우 회사는 이용자의 개인정보를 수집하기 위한 별도의 동의 절차를 마련하고 있습니다.  </p>
		<br>
		<li style="font-weight: bold;">제4조 개인정보의 제3자 제공에 관한 사항 </li>
		<p> 1.	회사는 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. </p>
		<br>
		<li style="font-weight: bold;">제5조 개인정보처리의 위탁에 관한 사항 </li>
		<p>1.	회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
	<table>
		<thead>
			<tr>
				<th>수탁자명</th>
				<th>위탁업무내용</th>
				<th>개인정보의 보유 및 이용기간</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>㈜유니트론IS</td>
				<td>홈페이지 운영 및 유지보수</td>
				<td rowspan='4' style="font-size: 14px; font-weight: bold;">위탁 계약 종료 시까지</td>
			</tr>
			<tr>
				<td>SK주식회사 AX(재수탁사: 한국마이크로소프트)</td>
				<td>인프라 운영, Azure 데이터 보관(국내)</td>
			</tr>
      <tr>
				<td>㈜오토업</td>
				<td>차대번호 조회</td>
			</tr>
      <tr>
				<td>NHN KCP</td>
				<td>온라인 PG 결제 대행 서비스</td>
			</tr>
		</tbody>
	</table>
		<p>2.	회사는 위탁 계약 체결 시 관계법령에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, </p>
		<p> &nbsp;수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. </p>
		<p>3.	위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다. </p>
		<br>

		<li style="font-weight: bold;">제6조 정보주체의 권리와 행사방법 </li>
		<p>1.	정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 및 철회 요구 등의 권리를 행사할 수 있습니다. </p>
		<p>※ 만 14세 미만 아동에 관한 개인정보의 열람등 요구는 법정대리인이 직접 해야 하며, 만 14세 이상의 미성년자인 정보주체는 정보주체의  </p>
		<p>개인정보에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도 있습니다. </p>
		<p>2.	권리 행사는 회사에 대해 ｢개인정보 보호법｣ 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다. </p>
		<p>3.	권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. </p>
		<p> &nbsp;이 경우 “개인정보 처리 방법에 관한 고시” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>
		<p>4.	개인정보 열람 및 처리 정지를 요구할 권리는 ｢개인정보 보호법｣ 제35조 제4항 및 제37조 제2항에 의하여 제한 될 수 있습니다. </p>
		<p>5.	다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 해당 개인정보의 삭제를 요구할 수 없습니다. </p>
		<p>6.	회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다. </p>
		<br>

		<li style="font-weight: bold;">제7조 개인정보 파기 절차 및 방법에 관한 사항 </li>
		<p>1.	회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. </p>
		<p>2.	개인정보 파기의 절차 및 방법은 다음과 같습니다. </p>
		<p>① 파기절차 </p>
		<p>회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을  </p>
		<p>받아 개인정보를 파기합니다. </p>
		<p>② 파기방법 </p>
		<p>회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할 수 없도록 파기하며,  </p>
		<p>종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다. </p>
		<br>

		<li style="font-weight: bold;"> 제8조 개인정보의 안전성 확보 조치에 관한 사항 </li>
		<p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다. </p>
		<p>1. 관리적 조치 : 내부관리계획 수립․시행, 정기적 직원 교육 </p>
		<p>2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 접속 기록의 위∙변조 방지를 위한 조치, 보안프로그램 설치 및 갱신 </p>
		<p>3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제 </p>
		<br>

		<li style="font-weight: bold;">제9조 개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항 </li>
		<p>1.	회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. </p>
		<p>2.	쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 </p>
		<p>보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다. </p>
		<p>가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다. </p>
		<p>나. 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다. </p>
		<p>             예1) 웹브라우저(Chrome) 우측 상단의 [설정] → [개인정보 및 보안] → [사이트 설정] → [쿠키 및 사이트 데이터] → 쿠키 차단 설정 </p>
		<p>예2) 웹브라우저(Edge) 우측 상단의 [설정] → [쿠키 및 사이트 권한] → 쿠키 및 저장된 데이터 → 쿠키 차단 설정 </p>
		<p>예3) 웹브라우저(Internet Explorer) 상단의 [도구] → [인터넷 옵션] → 개인정보 메뉴의 [고급] → 쿠키 차단 설정 </p>
    <p>예4) Safari의 경우 환경 설정 → '크로스 사이트 추적 방지' 및 '모든 쿠키 차단'</p>
		<p>다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다. </p>
		<br>

		<li style="font-weight: bold;">제10조 개인정보 보호책임자에 관한 사항 </li>
		<p>1.	회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. </p>
		<p>▶ 개인정보 보호책임자 </p>
		<p>성명 : 박현우 </p>
		<p>직책 : AI Innovation 그룹장  </p>
		<p>연락처 : 1588-4087 </p>
		<p>※ 개인정보 보호 담당부서로 연결됩니다. </p>
		<p>▶ 개인정보 보호 담당부서 </p>
		<p>부서명 : AI Innovation 그룹 </p>
		<p>담당자 : 임현진  </p>
		<p>연락처 : 1588-4087, tim98@sk.com </p>
		<p>2.	이용자는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.  </p>
		<p>회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다. </p>
		<br>

		<li style="font-weight: bold;">제11조 개인정보 열람청구를 접수처리하는 부서 </li>
		<p>1.	이용자는 ｢개인정보 보호법｣ 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리 되도록 노력하겠습니다. </p>
		<p>▶ 개인정보 열람청구 접수․처리 부서 </p>
		<p>부서명 : AI Innovation 그룹 </p>
		<p>담당자 : 임현진  </p>
		<p>연락처 : 1588-4087, tim98@sk.com </p>
		<br>

		<li style="font-weight: bold;">제12조 권익침해 구제방법 </li>
		<p>이용자는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다. </p>
		<p>아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다. </p>
		<br>

		<p>▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)</p>
		<p>- 소관업무 : 개인정보 침해사실 신고, 상담 신청 </p>
		<p>- 홈페이지 : privacy.kisa.or.kr </p>
		<p>- 전화 : (국번없이) 118 </p>
		<p>- 주소 : 전라남도 나주시 진흥길 9 한국인터넷진흥원 </p>
		<p>▶ 개인정보 분쟁조정위원회 </p>
		<p>- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결) </p>
		<p>- 홈페이지 : www.kopico.go.kr </p>
		<p>- 전화 : 1833-6972 </p>
		<p>- 주소 : 서울특별시 종로구 세종대로 209 정부서울청사 12층 </p>
		<p>▶ 대검찰청 사이버수사과 </p>
		<p>- (국번없이) 1301, privacy@spo.go.kr (www.spo.go.kr) </p>
		<p>▶ 경찰청 사이버수사국 </p>
		<p>- (국번없이) 182 (ecrm.police.go.kr) </p>
		<br>

		<li style="font-weight: bold;">제13조 추가적인 이용제공 관련 판단 기준 </li>
		<p>1.	회사는 「개인정보 보호법」 제15조제3항 및 제17조제4항에 따라 「개인정보 보호법」 시행령 제14조의2에 따른 사항을 고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있으며,  </p>
		<p>관련사항은 개인정보처리방침에 게재하여 정보주체가 확인할 수 있도록 안내를 하고 있습니다. </p>
		<p>2.	이에 따른 추가적인 이용 또는 제공할 때 판단기준은 다음과 같습니다. </p>
		<p>-	개인정보를 추가적으로 이용·제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부 </p>
		<p>-	개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 추가적인 이용·제공에 대한 예측 가능성이 있는지 여부 </p>
		<p>-	개인정보의 추가적인 이용·제공이 정보주체의 이익을 부당하게 침해하는지 여부 </p>
		<p>-	가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부 </p>
		<br>

		<li style="font-weight: bold;">제14조 개인정보처리방침 변경에 관한 사항 </li>
		<p>1.	이 개인정보 처리방침은 2026. 01. 29부터 적용됩니다. </p>

	</div>
</template>

<script>
export default {
	name: 'PrivacyPolicy_20260129'
}
</script>

<style scoped>
.sub_contents_wrap {
    padding-bottom: 50px;
    color: #444;
    line-height: 1.6;
    width: 1250px;
}

li {
    list-style: none;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 5px;
    font-size: 16px;
    color: #222;
    width: 950px;
}

p {
    margin-bottom: 3px;
    width: 950px;
    word-break: keep-all;
}

table {
    width: 950px;
    border-collapse: collapse;
    margin: 5px 0;
    font-size: 13px;
    border-top: 2px solid #888;
}

th,
td {
    border: 1px solid #ccc;
    padding: 6px;
    text-align: center;
}

th {
    background-color: #f9f9f9;
    font-weight: bold;
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/views/privacy/PrivacyPolicy_20260129.vue